import { cn } from "@/lib/utils";

import { CTAButton } from "./Button";

interface HookProps {
  title: string;
  subtitle?: string;
  /** Omitted where the surface already offers the same action of its own. */
  cta?: {
    label: string;
    onClick: () => void;
  };
}
/*


*/
export const Hook = ({ title, subtitle, cta }: HookProps) => {
  return (
    <article
      className={cn(
        "touch-device:h-50 bg-new-gray-900 w-full items-center justify-center flex flex-col gap-y-2.5 px-1 mobile:px-12",
        subtitle ? "h-40" : "h-33.5",
      )}
    >
      <div className="flex flex-col items-center justify-center text-center">
        <p className="text-base touch-device:text-xl font-semibold text-white">
          {title}
        </p>
        {subtitle && (
          <p className="text-xs touch-device:text-sm text-dark-secondary">
            {subtitle}
          </p>
        )}
      </div>
      {cta && (
        <div>
          <CTAButton onClick={cta.onClick} label={cta.label?.toUpperCase()} />
        </div>
      )}
    </article>
  );
};
